export default {
  setAutocompleteSource(state, value) {
    state.autocompleteSource = value;
  },
  setAutocompleteData(state, value) {
    state.autocompleteData = value;
  },
  setAuthorSlug(state, { value }) {
    state.filters.authorSlug = value;
  },
  setAdditionalOffset(state, value) {
    state.additionalOffset = value;
  },
  setCategorySlug(state, { value }) {
    state.filters.categorySlug = value;
  },
  setQuery(state, value) {
    state.filters.query = value;
  },
  setItems(state, { value }) {
    state.items = value;
  },
  setPagination(state, { value }) {
    state.pagination = value;
  },
  setLoading(state, value) {
    state.isLoading = value;
  },
  resetState(state) {
    state = Object.assign(state, {
      items: [],
      filters: {
        authorSlug: '',
        categorySlug: '',
        query: '',
      },
      orderBy: 'createdAt',
      orderDirection: 'desc',
      pagination: {
        limit: 12,
        offset: 0,
        countTotal: 0,
        currentPage: 1,
      },
    });
  },
};
